"use strict";

window.Components.Buttons.Close = createReactClass({
  onClick() {
    if (this.props.handler) {
      return this.props.handler();
    }
  },
  propTypes() {
    return {
      handler: PropTypes.func
    };
  },
  render() {
    return /* @__PURE__ */React.createElement("span", {
      className: "u-clickable u-fs22 u-fw400",
      onClick: this.onClick
    }, "\xD7");
  }
});